import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import config from "./config";

const httpLink = createHttpLink({
	uri: config.graphQL,
});

const authLink = setContext((_, { headers }) => {
	const storeToken = sessionStorage.getItem("corksy_store_access_token");
	const token = sessionStorage.getItem("vino_access_token");
	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : `Bearer ${storeToken}`,
		},
	};
});

const apolloClient = new ApolloClient({
	link: authLink.concat(httpLink),
	cache: new InMemoryCache(),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: "no-cache",
			errorPolicy: "ignore",
		},
		query: {
			fetchPolicy: "no-cache",
			errorPolicy: "all",
		},
	},
});

export default apolloClient;
